import { useComponentMountLogger } from "@amx/ux-twoui-telemetry";
import metadata from "./twoui-metadata.json";

const { version: twouiVersion } = metadata;

export const useComponentLogger = (
    componentName: string,
    id?: string
) => {

    useComponentMountLogger(twouiVersion, componentName, id);
};
